import { useState, useEffect, useCallback } from "react";

const headlines = [
  "replaces the SaaS you're tired of paying for",
  "your competitors wish they had",
  "makes your $800/mo subscription obsolete",
  "actually does exactly what you need",
  "turns your AI idea into a shipped product",
  "your dev agency quoted 6 months for — we do it in 6 weeks",
  "handles 900 orders a day without your team touching it",
  "answers 70% of your support tickets automatically",
  "knows your customers better than your sales team",
  "you stop renting and start owning",
  "makes your competitors look like they're from 2019",
  "your CFO will actually want to open every morning",
  "learns, adapts, and improves while you sleep",
  "replaces 5 tools with one system built for you",
  "your business runs on — built in weeks, not years",
];

const TYPE_SPEED = 55;
const DELETE_SPEED = 28;
const PAUSE_END = 2200;
const PAUSE_BEFORE_TYPE = 400;

export default function TypewriterHeadline() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const tick = useCallback(() => {
    const fullText = headlines[currentIndex];

    if (!isDeleting) {
      if (displayText.length < fullText.length) {
        return setTimeout(() => {
          setDisplayText(fullText.slice(0, displayText.length + 1));
        }, TYPE_SPEED);
      } else {
        return setTimeout(() => setIsDeleting(true), PAUSE_END);
      }
    } else {
      if (displayText.length > 0) {
        return setTimeout(() => {
          setDisplayText(displayText.slice(0, -1));
        }, DELETE_SPEED);
      } else {
        return setTimeout(() => {
          setIsDeleting(false);
          setCurrentIndex((prev) => (prev + 1) % headlines.length);
        }, PAUSE_BEFORE_TYPE);
      }
    }
  }, [currentIndex, displayText, isDeleting]);

  useEffect(() => {
    const timer = tick();
    return () => clearTimeout(timer);
  }, [tick]);

  return (
    <span
      className="typewriter-gradient font-mono font-bold relative inline-block"
      aria-label={headlines[currentIndex]}
    >
      {displayText}
      <span className="typewriter-cursor" aria-hidden="true" style={{ position: 'absolute', right: '-0.6em', top: 0 }}>|</span>
    </span>
  );
}
